module.exports = __webpack_public_path__ + "static/media/badge_ESP_Google.8c4b3ee9.png";